// #======================================#
// #     _____       _ _       _  _       #
// #    |  __ \     (_) |     | || |      #
// #    | |__) |__ _ _| |___  | || |_     #
// #    |  _  // _` | | / __| |__   _|    #
// #    | | \ \ (_| | | \__ \    | |      #
// #    |_|  \_\__,_|_|_|___/    |_|      #
// #                                      #
// #======================================#

//I18n.translate("admin_auctioneer_" ,{default: "aaa", param: "hello", ... })
var I18n = {};
I18n.translate = function(key,params) {
    var value = TRANSLATIONS[key];
    if (value === null || typeof value === "undefined") {
      if (params && params['default']) {
        value = params['default'];
      }
      else {
        return "translation missing: "+key;
      }
    }
    return value.replace(/%\{(.*?)\}/g,function (match,param_name) { return params[param_name];} );
};

I18n.current_locale = function () {
  if (typeof(I18n.locale) === "undefined" || I18n.locale === null) {
      var locale ;
      if (document.domain.match(/\.nl$/) || document.domain.match(/\.be$/)) {
        locale = "nl";
      }
      else if (document.domain.match(/\.de$/))  {
        locale = "du"; //catawiki specific.
      }
      else if (document.domain.match(/\.fr$/) || document.domain.match(/\.eu$/)) {
        locale = "fr";
      }
      else if (document.domain.match(/\.co\.uk$/) || document.domain.match(/\.com$/)) {
        locale = "en";
      }

      if (locale) {
        I18n.locale = locale;
      }
      else {
        I18n.locale = "nl";
      }

  }
  return I18n.locale;
};

I18n.format_amount_in_euros = function (amount,locale) {
  var currencyCode = "€";
  locale = locale || I18n.current_locale();
  return I18n.format_amount_in_currency(amount, currencyCode, locale, { 'prependCurrencySymbol' : true });
};

I18n.format_amount_in_euros_decimals = function (amount,locale) {
  var currencyCode = "€";
  locale = locale || I18n.current_locale();
  return I18n.format_amount_in_currency_decimals(amount, currencyCode, locale, { 'prependCurrencySymbol' : true });
};

I18n.format_amount_in_currency = function (amount, currencyCode, locale, options) {
  if (!options) {
    options = {};
  }
  var prefix = currencyCode + " ";
  var amount_integer = String(parseInt(amount,10));
  switch(locale || I18n.current_locale()) {
    case "nl": amount_integer = I18n.number_format(amount_integer, ",", ".", "."); break;
    case "en": amount_integer = I18n.number_format(amount_integer, ".", ",", ","); break;
    case "du": amount_integer = I18n.number_format(amount_integer, ",", ".", " "); break;
    case "fr": amount_integer = I18n.number_format(amount_integer, ",", " ", " "); break;
  }
  if (options.prependCurrencySymbol) {
    return prefix + amount_integer;
  } else {
    return amount_integer;
  }
};

I18n.format_amount_in_currency_decimals = function (amount, currencyCode, locale, options) {
  if (!options) {
    options = {};
  }
  var prefix = currencyCode + " ";
  var amount_float = String(amount.toFixed(2));
  switch(locale || I18n.current_locale()) {
    case "nl": amount_float = I18n.number_format(amount_float, ",", ".", "."); break;
    case "en": amount_float = I18n.number_format(amount_float, ".", ",", ","); break;
    case "du": amount_float = I18n.number_format(amount_float, ",", ".", " "); break;
    case "fr": amount_float = I18n.number_format(amount_float, ",", " ", " "); break;
  }
  if (options.prependCurrencySymbol) {
    return prefix + amount_float;
  } else {
    return amount_float;
  }
};

I18n.number_format = function (nStr, dec_point, first_thousands_sep,thousands_sep) {
    nStr += '';
    var x = nStr.split(".");
    var x1 = x[0];
    var x2 = x.length > 1 ? dec_point + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    if (rgx.test(x1)) {
      // console.log("match",x1);
      x1 = x1.replace(rgx, '$1' + first_thousands_sep + '$2');
    }

    while (rgx.test(x1)) {
      // console.log("match",x1);
      x1 = x1.replace(rgx, '$1' + thousands_sep + '$2');
    }

    return x1 + x2;
};



/*
  returns an array of day names for the current locale, or, if not there: english.
  the index of the array items matches values returned from date.getDay()
*/
I18n.day_names = function () {
  var day_names = {
    "nl": ["Zondag","Maandag","Dinsdag","Woensdag","Donderdag","Vrijdag","Zaterdag"],
    "en": ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]
  };
  if (day_names[I18n.current_locale()]) {
    return day_names[I18n.current_locale()];
  }
  else {
    return day_names.en;
  }
};
